"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoctisFarming = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var NoctisFarming = (function (_super) {
    __extends(NoctisFarming, _super);
    function NoctisFarming() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.NOCTIS_FARMING,
            tags: [Tags_1.Tags.PLANT, Tags_1.Tags.BUILDING],
            cost: 10,
            productionBox: Units_1.Units.of({ megacredits: 1 }),
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.temperature(-20); }),
            metadata: {
                cardNumber: '176',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.megacredits(1);
                    }).nbsp.plants(2);
                }),
                description: 'Requires -20 C or warmer. Increase your M€ production 1 step and gain 2 Plants.',
                victoryPoints: 1,
            },
        }) || this;
    }
    NoctisFarming.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 1);
        player.plants += 2;
        return undefined;
    };
    NoctisFarming.prototype.getVictoryPoints = function () {
        return 1;
    };
    return NoctisFarming;
}(Card_1.Card));
exports.NoctisFarming = NoctisFarming;
//# sourceMappingURL=NoctisFarming.js.map